import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=b566b7b4&"
import script from "./UserManagement.vue?vue&type=script&lang=js&"
export * from "./UserManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b566b7b4')) {
      api.createRecord('b566b7b4', component.options)
    } else {
      api.reload('b566b7b4', component.options)
    }
    module.hot.accept("./UserManagement.vue?vue&type=template&id=b566b7b4&", function () {
      api.rerender('b566b7b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/UserManagement.vue"
export default component.exports